import React from 'react';
import PropTypes from 'prop-types';
import ProductInstanceShape from '../../shapes/product-instance';
import { translate } from 'react-i18next';
import { classes } from './styles/table';
import AgGridReact from '../common/ag-table';
import DateShortCellComponent from "../common/date-short-cell";
import ProductIDCellComponent from "../common/product-id-cell";

class ProductInstanceTableView extends React.Component {

  onRowSelected = event => {
    const { onSelect, onUnselect, disabled } = this.props;
    if (!(onSelect && onUnselect) || disabled) {
      return null; // Ignore, functions aren't present to invoke
    }
    if (event.node.selected) {
      onSelect(event.data.uuid, event.data, event);
    } else {
      onUnselect(event.data.uuid, event.data, event);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selected === this.props.selected) {
      return null;
    }
    if (!this.gridApi) {
      return null;
    }
    let { selected = [] } = this.props;
    selected = Array.isArray(selected) ? selected : [selected];
    this.gridApi.forEachNode(
      node => node.setSelected(selected.indexOf(node.data.uuid) > -1)
    );
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  onDeleteClicked = (event, action, { data: { actions: unused, ...data } }) => {
    const remove = () => {
      this.gridApi.updateRowData({
        remove: [
          data
        ]
      })
    };

    if (!data.uuid) {
      return remove();
    }

    return this.props.onDelete(data, remove);
  };

  render() {
    const { t, items, emptyMessage, customers, locations, batch, className } = this.props;
    const getLocation = parentUuid => {
      const location = locations.find(({ uuid }) => uuid === parentUuid);
      if (location) {
        return location.name;
      }
      const customer = customers.find(({ uuid }) => uuid === parentUuid);
      if (customer) {
        return customer.name;
      }
      return ''
    };
    return (
      <div
        className={`ag-theme-blue ${classes.table} ${className || ''}`}
      >
        <AgGridReact
          name="product-instance"
          sizeColumnsToFit
          onGridReady={this.onGridReady}
          onRowSelected={this.onRowSelected}
          rowSelection={batch ? 'multiple' : 'single'}
          rowMultiSelectWithClick={batch}
          rowDeselection
          enableFilter
          enableSorting
          frameworkComponents={{
            DateShortCellComponent,
            ProductIDCellComponent
          }}
          columnDefs={[
            {
              field: 'parentFormatted',
              headerName: t('table.parentHeader')
            },
            {
              field: 'productId',
              headerName: t('table.productHeader'),
              cellRenderer: 'ProductIDCellComponent'
            },
            {
              field: 'systemIdentifier',
              headerName: t('table.systemIdentifierHeader')
            },
            {
              field: 'description',
              headerName: t('table.descriptionHeader')
            },
            {
              field: 'productVersion',
              headerName: t('table.versionHeader')
            },
            {
              field: 'paidThrough',
              headerName: t('table.paidThroughHeader'),
              cellRenderer: 'DateShortCellComponent'
            }
          ]}
          items={
            items
              .map(
                item => ({
                  ...item,
                  parentFormatted: getLocation(item.parentUuid)
                })
              )
          }
          localeText={{
            noRowsToShow: emptyMessage || t('table.emptyMessage')
          }}
          cleanActions={[
            {
              name: 'Delete',
              onClick: this.onDeleteClicked
            }
          ]}
        />
      </div>
    );

  }

}

ProductInstanceTableView.propTypes = {
  batch: PropTypes.bool,
  items: PropTypes.arrayOf(
    ProductInstanceShape.isRequired
  ).isRequired,
  onUnselect: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.string.isRequired
    )
  ]),
  emptyMessage: PropTypes.string,
  disabled: PropTypes.bool,
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  jurisdictions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  ),
  filter: PropTypes.string,
  className: PropTypes.string
};

export default translate(['productInstance'])(ProductInstanceTableView);



// WEBPACK FOOTER //
// ./src/views/product-instance/table.js